<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="unidades"
      :server-items-length="totalUnidades"
      :loading="loading"
      :page="page"
      :page-count="numberOfPages"
      :options.sync="options"
      :sort-by.sync="sortBy"
    >
      <template v-slot:header>
        <div class="header-table">
          <UnityFilter @resource="handleFilterResource" />
          <v-btn class="rounded-lg ml-2" elevation="1" color="#2a6334" @click="dialog = true, resource = {}">
            <v-icon style="color: white">mdi-plus</v-icon>
            <span class="textBtn">NOVA UNIDADE</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.opoOpc`]="{ item }">
        <span v-if="item.opo_reference && item.opc_reference">
          {{ item.opo_reference.description }}/{{ item.opc_reference.description }}
        </span>
        <span v-else>-</span>
      </template>

      <template v-slot:[`item.orgaos`]="{ item }">
        <div class="d-flex flex-wrap">
          <v-chip
            v-for="(orgao, index) in item.unity_orgons"
            :key="index"
            color="#bce8d3"
            text-color="red"
            small
            class="ma-1"
          >
            <span v-if="orgao && orgao.orgon">{{ orgao.orgon.name }}</span>
          </v-chip>
        </div>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip
          small
          :color="item.deleted_at ? 'red lighten-1' : 'green lighten-3'"
          :text-color="item.deleted_at ? 'white' : 'green darken-3'"
        >
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>

      <template v-slot:[`item.type_unity`]="{ item }">
        <v-chip color="#bce8d3" small>
          {{ item.transplanted_orgon_flg == '0' ? 'Unidade Médica' : 'Unidade Transplantadora' }}
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="dialog = true, resource = item">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="loadGridData()"
            url="unities"
          />
        </Menu>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <UnidadeForm :openDialog="dialog" :centroForm="resource" @closeDialog="dialog = false, loadGridData(), resource = {}" />
    </Modal>
  </div>
</template>

<script>
import { getUnities, getAllOrgons } from "@/service/basic-registrations/UnitiesService";
import UnidadeForm from "./Unity.vue";
import UnityFilter from "./Filter.vue";
import Menu from "../widgets/MenuActions-comp.vue";
import ChangeStatus from "../widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";

export default {
  components: {
    UnidadeForm,
    UnityFilter,
    Menu,
    ChangeStatus,
    CrudGrid,
    Modal,
  },

  data() {
    return {
      dialog: false,
      headers: [
        { text: "Unidade Hospitalar", align: "center", value: "hospital" },
        { text: "Tipo de Unidade", align: "center", value: "type_unity" },
        { text: "CNES", align: "center", value: "cnes" },
        { text: "Município", align: "center", value: "municipality" },
        { text: "OPO/OPC", align: "center", value: "opoOpc" },
        { text: "Orgãos Transplantados", align: "center", value: "orgaos" },
        { text: "Status", align: "center", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 1,
      totalUnidades: 0,
      numberOfPages: 0,
      loading: true,
      options: {},
      sortBy: "name",
      unidades: [],
      filter: {},
      orgons: [],
      resource: {},
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "UnidadeForm",
        },
      ],
    };
  },

  watch: {
    options: {
      handler() {
        this.loadGridData();
      },
    },

    filter: {
      deep: true,
      handler() {
        this.options.page = 1;
        this.loadGridData();
      },
    },
  },

  created() {
    this.changeActionsData(this.actions);
  },

  mounted() {
    this.loadGridData();
    this.getOrgons();
  },

  methods: {
    ...mapActions(["changeActionsData"]),

    handleFilterResource(data) {
      this.unidades = data;
      this.loading = false;
    },

    loadGridData() {
      this.loading = true;
      const { page } = this.options;
      const pageNumber = page || 1;

      getUnities({
        ...this.filter,
        page: pageNumber,
        per_page: '',
      }).then((result) => {
        this.loading = false;
        this.unidades = result.data;
        this.totalUnidades = result.total;
        this.numberOfPages = result.last_page;
      });
    },

    getOrgons() {
      getAllOrgons().then((result) => {
        this.orgons = result;
      });
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 16px 16px 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
